import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'

export default class SubscriptionID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
